// extracted by mini-css-extract-plugin
module.exports = {"RichText":"styles_RichText__LLXg6"};